import { RouteInfo } from './vertical-menu.metadata';

export const ROUTES: RouteInfo[] = [];
